/* Designer Plants collection/search add-to-cart feedback.
   Shopify's native theme owns the add request and cart drawer. This script only confirms success. */
(function(){
  'use strict';
  if(window.dpCollectionAtcFeedbackBound)return;
  window.dpCollectionAtcFeedbackBound=true;

  var BUTTON_SELECTOR='.product-item__action-list [data-action="add-to-cart"]';
  var pending=null;
  var timers=[];

  function closestFrom(node,selector){
    if(!node)return null;
    var el=node.nodeType===1?node:node.parentElement;
    return el&&el.closest?el.closest(selector):null;
  }
  function cartUrl(){
    var root=(window.Shopify&&window.Shopify.routes&&window.Shopify.routes.root)||(window.routes&&window.routes.rootUrl)||'/';
    if(root.charAt(root.length-1)!=='/')root+='/';
    return root+'cart.js';
  }
  function readCartCount(){
    var el=document.querySelector('.header__cart-count');
    var count=el?parseInt((el.textContent||'').trim(),10):NaN;
    if(isNaN(count)&&window.theme&&typeof window.theme.cartCount==='number')count=window.theme.cartCount;
    return isNaN(count)?0:count;
  }
  function setCartCount(count){
    if(window.theme)window.theme.cartCount=count;
    Array.prototype.forEach.call(document.querySelectorAll('.header__cart-count'),function(el){el.textContent=count;});
  }
  function clearTimers(){
    while(timers.length)clearTimeout(timers.pop());
  }
  function restore(record){
    if(!record)return;
    if(record.button&&document.documentElement.contains(record.button)){
      record.button.removeAttribute('aria-busy');
      record.button.textContent=record.original;
    }
    if(pending===record)pending=null;
  }
  function success(record,count){
    if(!record||pending!==record||record.done)return;
    record.done=true;
    clearTimers();
    if(typeof count==='number')setCartCount(count);
    if(record.button&&document.documentElement.contains(record.button)){
      record.button.removeAttribute('aria-busy');
      record.button.textContent='Added ✓';
    }
    timers.push(setTimeout(function(){restore(record);},1700));
  }
  function checkCart(record){
    if(!record||pending!==record||record.done)return;
    fetch(cartUrl(),{credentials:'same-origin',headers:{Accept:'application/json'}})
      .then(function(response){if(!response.ok)throw new Error('Cart check failed');return response.json();})
      .then(function(cart){
        if(pending!==record||record.done)return;
        if(cart&&typeof cart.item_count==='number'&&cart.item_count>record.beforeCount)success(record,cart.item_count);
      })
      .catch(function(){});
  }

  document.addEventListener('click',function(event){
    var button=closestFrom(event.target,BUTTON_SELECTOR);
    if(!button||button.disabled)return;
    if(pending)restore(pending);

    var record={
      button:button,
      original:(button.textContent||'').replace(/\s+/g,' ').trim(),
      beforeCount:readCartCount(),
      done:false
    };
    pending=record;
    button.setAttribute('aria-busy','true');
    button.textContent='Adding';

    timers.push(setTimeout(function(){checkCart(record);},500));
    timers.push(setTimeout(function(){checkCart(record);},1100));
    timers.push(setTimeout(function(){checkCart(record);},2000));
    timers.push(setTimeout(function(){if(pending===record&&!record.done)restore(record);},3600));
  },true);

  document.addEventListener('product:added',function(){
    var record=pending;
    if(record&&!record.done)setTimeout(function(){checkCart(record);},60);
  });
})();
